<div [formGroup]="this.formGroup" class="mt-{{FIELD_SPACING}}">
  <div class="row">
    <div class="col">
      <div class="form-label">{{this.label}}</div>     
    </div>
  </div>
  <div class="mt-{{LABEL_SPACING}} mb-1">
    <div class="">
      <div *ngFor="let type of this.radioData">
        <label class="container-radio mb-15" for="{{this.propertyId}}{{type.value}}">
          {{type.label}}
          <input
            id="{{this.propertyId}}{{type.value}}"
            name="{{this.propertyName}}"
            type="radio"  
            value={{type.value}}
            (click)="this.userAction(type.value)"
            formControlName="{{this.propertyName}}">
            <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
  <app-validator-message [formGroup]="this.formGroup" propertyName="{{this.propertyName}}"></app-validator-message>
</div>